import { Col, Form, Input } from 'antd';
import React, { FC } from 'react'
import { PrefixGameMetaTypes } from '~types/prefixs'

interface GameMetaGroupProps {
    gameMeta?: Record<PrefixGameMetaTypes, string>
}
export const UsunGroup: FC<GameMetaGroupProps> = ({ gameMeta }) => {
    return (
        <>
            <Col xs={24} sm={24}>
                <Form.Item
                    name={["gameMeta", "key"]}
                    label="Usun Key"
                    rules={[{ required: true, message: 'กรุณากรอก Usun Key!' }]}
                    hasFeedback>
                    <Input placeholder="Usun Key" inputMode="text" />
                </Form.Item>
            </Col>
        </>
    )
}
